import { render, staticRenderFns } from "./FailedLoginsTable.vue?vue&type=template&id=7cc0bc07&scoped=true&"
import script from "./FailedLoginsTable.vue?vue&type=script&lang=js&"
export * from "./FailedLoginsTable.vue?vue&type=script&lang=js&"
import style0 from "./FailedLoginsTable.vue?vue&type=style&index=0&id=7cc0bc07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0bc07",
  null
  
)

export default component.exports